import PropTypes from "prop-types";
import { ReactComponent as StarFillIcon } from '../../../../../../assets/icons/ic_star.svg';
import ImageHelper from "../../../../../../utilities/helpers/ImageHelper";
import ProfileImage from "../../../../common/ProfileImage"
import {DateFormatHelper} from "../../../../../../utilities/helpers/DateFormatHelper";

const StarRating = ({ rating }) => {
    return (
        <div className="star-rating d-flex">
            <span className="review-rate">{parseFloat(rating).toFixed(1)}</span>
            <StarFillIcon width={12} height={12} style={{ color: '#22264C99',marginTop:1.5 }}/>
        </div>
    );
};

const SlotBookingReviewItem = ({review}) => {
    return (
        <div className="review_section">
            <div className="d-flex justify-between">
                <div className="d-flex items-center" style={{gap: 12}}>
                    <ProfileImage name={review.customer.name} photo={review?.customer.avatar} size={{width: 32, height: 32, fontSize: 13, lineHeight: 16}}/>
                    <div>
                        <h4 className="review_title truncate" title={review.customer.name}>{review.customer.name}</h4>
                        <h4 className="review_date">{DateFormatHelper.monthYearTimeFormat(review.created_at)}</h4>
                    </div>
                </div>
                <div className="d-flex">
                    <StarRating rating={review.rating}/>
                </div>
            </div>
            <div className="review_descriptions" style={{marginTop: review.text ? 16 : 0}}>
                <h4 title={review.text}>{review.text}</h4>
            </div>
            {
                review.assets && review.assets.length > 0 ? (
                    <div className="review_image_wrappper">
                        {
                            review.assets?.map((image, index) => (
                                <img
                                    key={index}
                                    src={ImageHelper.getFullImageUrl(image)}
                                    className="review-image"
                                />
                            ))
                        }
                    </div>
                ) : null
            }
        </div>
    )   
}

SlotBookingReviewItem.propTypes = {
    review: PropTypes.object.isRequired
};

export default SlotBookingReviewItem;